// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_jl-0";